import {NetworkEnums} from '../../../../shared/GameEnums'
import {MatchmakingCancelReason} from '../../../../shared/matchmaking/MatchmakingEnums'
import {MatchmakingRequest} from '../../../../shared/matchmaking/MatchmakingInterfaces'
import {UIGameSpriteHandler} from '../UIGameSpriteHandler'
import {socket} from '../EntryShared'
import {MatchmakingAction, PRIMARY_MATCHMAKING_ACTIONS} from '@colonist/lobby-types'
import {ClientMessageSubType, TimeoutId} from '@colonist/types'
import SendMatchmakingActionData = NetworkEnums.SendMatchmakingActionData

export class SocketMatchmakingSend {
    static lastMatchmakingRequest: MatchmakingRequest | undefined
    static matchmakingRequestDelayMs: number = 1000
    static delayMatchmakingTimeout: TimeoutId | undefined

    private static send(action: MatchmakingAction, data: any) {
        const actionDataToSend: SendMatchmakingActionData = {
            action: action,
            payload: data,
        }
        socket.controller.sender.sendToServerType(ClientMessageSubType.MatchmakingAction, 'lobby', actionDataToSend, PRIMARY_MATCHMAKING_ACTIONS.includes(action))
    }

    static sendFindGame() {
        if(!this.lastMatchmakingRequest) return
        this.send(MatchmakingAction.ClickedFindGame, this.lastMatchmakingRequest)
    }

    static enterMatchmaker(matchmakingRequest: MatchmakingRequest, shouldDelay: boolean = true) {
        this.lastMatchmakingRequest = matchmakingRequest
        this.clearDelayMatchmakingTimeout()

        if(shouldDelay) {
            this.delayMatchmakingTimeout = setTimeout(() => {
                void UIGameSpriteHandler.continueAfterAssetsLoad(() => {
                    this.sendFindGame()
                })
            }, this.matchmakingRequestDelayMs)
            return
        }

        void UIGameSpriteHandler.continueAfterAssetsLoad(() => {
            this.sendFindGame()
        })
    }

    static storeMatchmakingRequest(matchmakingRequest: MatchmakingRequest) {
        this.lastMatchmakingRequest = matchmakingRequest
        this.clearDelayMatchmakingTimeout()
    }

    static sendCancelFindGame(reason: MatchmakingCancelReason) {
        this.lastMatchmakingRequest = undefined

        this.clearDelayMatchmakingTimeout()

        this.send(MatchmakingAction.ClickedCancelFindGame, reason)
    }

    private static clearDelayMatchmakingTimeout(): void {
        clearTimeout(this.delayMatchmakingTimeout)
        this.delayMatchmakingTimeout = undefined
    }
}
